import React from 'react';
import styles from '../landing.module.scss';

import lightningIcon from '../../../assets/images/landing/feature-lightning.svg';
import arrowIcon from '../../../assets/images/landing/feature-up-arrow.svg';
import gearIcon from '../../../assets/images/landing/feature-gear.svg';

const FeatureCards = () => {
    const cards = [
        {
            title: "Market Intelligence & Competitor Tracking",
            subTitle: "Turning scattered marketplace data into actionable insights for VR studios and publishers.",
            description: "Explore report →",
            color: "blue",
            icon: arrowIcon
        },
        {
            title: "Keyword & ASO Optimization for Meta Quest",
            subTitle: "Discovery, tracking, and ranking analysis for visibility improvement on Meta.",
            description: "Learn More →",
            color: "yellow",
            icon: lightningIcon
        },
        {
            title: "Grow your VR business with robust SaaS tools",
            subTitle: "Turning scattered marketplace data into actionable insights for VR studios and publishers.",
            description: "Request free demo →",
            color: "pink",
            icon: gearIcon
        }
    ];

    return (
        <section className={styles.featureCardsSection}>
            <div className={styles.container}>
                <div className={styles.cardsGrid}>
                    {cards.map((card, index) => (
                        <div
                            key={index}
                            className={`${styles.featureCard} ${styles[card.color]}`}
                        >
                            <h3>{card.title}</h3>
                            <p>{card.subTitle}</p>
                            <div className={styles.cardFooter}>
                                <span className={styles.cardCta}>{card.description}</span>
                                <div className={styles.cardIcon}>
                                    <img src={card.icon} alt="" />
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FeatureCards;
